import { SimpleEventEmitter } from "../utils/SimpleEventEmitter";

export class LocalPubSubStore {
  timereportUpdated = new SimpleEventEmitter<{ timereportId: string, status: any }>();
  accommodationConfirmationUpdated = new SimpleEventEmitter();
  financeFormUpdated = new SimpleEventEmitter();
}
